import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import OnboardingPage from './Onboarding'

export default () => [
  <Redirect exact key="register" from="/register/:jwtData?" to="/signup/:jwtData?" />,
  <Route exact key="signup" path="/signup/:jwtData?" component={OnboardingPage} />,
]
